import { useContext, memo, useState, useRef, useEffect } from 'react'

// @mui material components
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

// Soft UI Dashboard React themes
import theme from 'assets/theme'
import 'App.css'

// Soft UI Dashboard PRO React routes
import routes from 'routes'

// Old Layout
// import Sidenav from 'examples/Sidenav'
// New Layout
import Sidenav from 'components/Sidenav'
// Images
// import brand from 'assets/images/parco.webp'
import brand from 'assets/images/parco-white.png'
import brandNavy from 'assets/images/parco.webp'
import { AppRoutes } from 'AppRoutes'
import { CenteredLoadingContainer } from 'components/Loading'
import { IntakeContext } from 'context/IntakeContext'
import { useSoftUIController, setMiniSidenav } from 'context'
import { ModalProvider } from 'components/modals'
import { Box } from '@mui/material'

export const PageContainer = memo(() => {
  const {
    loading: userIsLoading,
    intakeState,
    assumedUser,
  } = useContext(IntakeContext)
  const [controller, dispatch] = useSoftUIController()
  const { miniSidenav, layout, sidenavColor } = controller
  const [onMouseEnter, setOnMouseEnter] = useState(false)
  const sidenavRef = useRef(null)

  // // Open sidenav when mouse enter on mini sidenav
  // const handleOnMouseEnter = () => {
  //   if (miniSidenav && !onMouseEnter) {
  //     setMiniSidenav(dispatch, false)
  //     setOnMouseEnter(true)
  //   }
  // }

  // // Close sidenav when mouse leave mini sidenav
  // const handleOnMouseLeave = () => {
  //   if (onMouseEnter) {
  //     setMiniSidenav(dispatch, true)
  //     setOnMouseEnter(false)
  //   }
  // }

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        window.innerWidth < 992 &&
        sidenavRef.current &&
        !sidenavRef.current.contains(event.target)
      ) {
        setMiniSidenav(dispatch, true)
        setOnMouseEnter(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <ModalProvider>
        <CssBaseline />
        {layout === 'dashboard' ? (
          <>
            <Sidenav
              ref={sidenavRef}
              color={sidenavColor}
              brand={brand}
              brandName=""
              routes={routes}
              // onMouseEnter={handleOnMouseEnter}
              // onMouseLeave={handleOnMouseLeave}
            />
            {assumedUser && (
              <Box
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  fontSize: '13px',
                  paddingLeft: `${miniSidenav ? '0px' : '300px'}`,
                  transition: 'padding-left 0.3s ease',
                  textAlign: 'center',
                  zIndex: 1101,
                  position: 'sticky',
                  top: '0',
                }}
              >
                You have Assumed the Role of{' '}
                {intakeState.firstName && intakeState.lastName
                  ? `${intakeState.firstName} ${intakeState.lastName}`
                  : '(user)'}
              </Box>
            )}
          </>
        ) : (
          <></>
        )}
        {userIsLoading ? (
          <>
            <CenteredLoadingContainer
              topComponent={
                <Box
                  sx={{ paddingTop: '5px' }}
                  component="img"
                  src={brandNavy}
                  alt="PARCO Logo"
                />
              }
            />
          </>
        ) : (
          <div className="App">
            <AppRoutes />
          </div>
        )}
      </ModalProvider>
    </ThemeProvider>
  )
})

PageContainer.displayName = 'PageContainer'
